import React from 'react';
import './InfoPage.css';

function Cancellation() {
  return (
    <div className="info-page">
      <div className="info-container">
        <h1>Opções de Cancelamento</h1>

        <section className="info-section">
          <h2>Entendendo as Políticas de Cancelamento</h2>
          <p>Cada propriedade na Nukki possui uma política de cancelamento definida pelo anfitrião. Revise a política antes de reservar para entender suas opções.</p>
        </section>

        <section className="info-section">
          <h3>Políticas de Cancelamento</h3>

          <div className="policy-card">
            <h4>Flexível</h4>
            <p><strong>Reembolso total:</strong> Cancele até 24 horas antes do check-in</p>
            <p><strong>Reembolso de 50%:</strong> Cancele dentro de 24 horas do check-in</p>
            <p><strong>Sem reembolso:</strong> Após o check-in</p>
          </div>

          <div className="policy-card">
            <h4>Moderada</h4>
            <p><strong>Reembolso total:</strong> Cancele até 5 dias antes do check-in</p>
            <p><strong>Reembolso de 50%:</strong> Cancele dentro de 5 dias do check-in</p>
            <p><strong>Sem reembolso:</strong> Após o check-in</p>
          </div>

          <div className="policy-card">
            <h4>Rigorosa</h4>
            <p><strong>Reembolso total:</strong> Cancele dentro de 48 horas da reserva, se o check-in for em pelo menos 14 dias</p>
            <p><strong>Reembolso de 50%:</strong> Cancele pelo menos 7 dias antes do check-in</p>
            <p><strong>Sem reembolso:</strong> Cancele dentro de 7 dias do check-in</p>
          </div>

          <div className="policy-card">
            <h4>Super Rigorosa</h4>
            <p><strong>Reembolso de 50%:</strong> Cancele pelo menos 30 dias antes do check-in</p>
            <p><strong>Sem reembolso:</strong> Cancele dentro de 30 dias do check-in</p>
          </div>
        </section>

        <section className="info-section">
          <h3>Como Cancelar uma Reserva</h3>
          <ol>
            <li>Vá para o painel da sua conta</li>
            <li>Encontre sua reserva em "Próximas Viagens"</li>
            <li>Clique nos detalhes da reserva</li>
            <li>Selecione "Cancelar Reserva"</li>
            <li>Revise o valor do reembolso baseado na política de cancelamento</li>
            <li>Confirme seu cancelamento</li>
          </ol>
          <p>Você receberá um e-mail de confirmação com detalhes sobre seu reembolso, que normalmente é processado dentro de 5 a 10 dias úteis.</p>
        </section>

        <section className="info-section">
          <h3>Circunstâncias Atenuantes</h3>
          <p>Entendemos que às vezes eventos inesperados ocorrem. Nossa Política de Circunstâncias Atenuantes pode permitir cancelamentos ou alterações com reembolso total em casos como:</p>
          <ul>
            <li>Doença grave ou lesão</li>
            <li>Falecimento de um hóspede ou membro familiar imediato</li>
            <li>Desastres naturais ou clima severo</li>
            <li>Restrições de viagem impostas pelo governo</li>
            <li>Problemas importantes na propriedade (sem energia, aquecimento ou água)</li>
          </ul>
          <p>Documentação pode ser necessária para qualificar-se para esta política.</p>
        </section>

        <section className="info-section">
          <h3>Cancelamentos pelo Anfitrião</h3>
          <p>Se um anfitrião cancelar sua reserva, você receberá reembolso total e pode ser elegível para compensação adicional. Anfitriões são fortemente desencorajados de cancelar, pois isso afeta o status de seus anúncios.</p>
        </section>

        <section className="info-section">
          <h3>Precisa de Ajuda?</h3>
          <p>Se você tiver dúvidas sobre suas opções de cancelamento ou precisar de assistência, nossa equipe de suporte está disponível 24/7.</p>
        </section>
      </div>
    </div>
  );
}

export default Cancellation;
